module.exports = __webpack_public_path__ + "static/media/login.eca3fd7b.svg";